// components/DnDMonsterStats.styled.ts

import styled from "styled-components";

import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours"; // Adjust the import path as necessary
import { Span, SubTitle } from "utils/styling/typography.styled";

export const Container = styled.div`
    padding: 0.5rem;
    background: ${colourScheme.primary};
    border-radius: 0.5rem;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.3);
    margin-top: 0.75rem;
`;

export const Header = styled(SubTitle)`
    text-align: center;
    color: ${colourScheme.fullWhite};
    margin-bottom: 0.5rem;
`;

export const StatItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.25rem 0.5rem;
    background-color: ${colourScheme.primaryLight};
    border-radius: 0.5rem;
    margin-bottom: 0.25rem;
`;

export const StatLabel = styled(Span)`
    font-weight: bold;
    color: ${colourScheme.secondaryLight};
    margin: 0 0.5rem;
    min-width: 5rem;
    ${device.md} {
        min-width: 8rem; // Ensure consistent width
    }
    text-wrap: wrap;
    word-break: break-word;
    display: inline-block;
`;

export const StatValue = styled.span`
    color: ${colourScheme.fullWhite};
    text-wrap: pretty;
`;

export const GridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(12rem, 1fr));
    gap: 0.5rem;
    margin-bottom: 0.5rem;
    padding: 0.5rem;
    background: ${colourScheme.primaryDark};
    border-radius: 0.5rem;
`;

export const DisclosureContainer = styled.div`
    .disclosure-button {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 0.75rem 1rem;
        background: ${colourScheme.primaryLight};
        color: ${colourScheme.fullWhite};
        border: none;
        border-radius: 0.25rem;
        cursor: pointer;
        font-size: 1rem;
        transition: background 0.3s ease;

        &:hover {
            background: ${colourScheme.primaryDark};
        }

        .icon {
            width: 1.25rem;
            height: 1.25rem;
        }
    }

    .disclosure-panel {
        background: ${colourScheme.primaryDark};
        border-radius: 0.5rem;
        margin-top: 0.25rem;
        transition: all 0.3s ease;
        transform-origin: top;
        &[data-state="open"] {
            animation: openAnimation 0.3s ease forwards;
        }
        &[data-state="closed"] {
            animation: closeAnimation 0.3s ease forwards;
        }
    }
`;

export const Icon = styled.div`
    all: unset;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 1.5rem;
    width: 1.5rem;
    cursor: pointer;
    position: relative;
    margin-left: 0.2rem;
    svg,
    img {
        opacity: 0.5;
        height: 100%;
        width: 100%;
    }
    & > span {
        padding: 0.25rem;
        color: ${colourScheme.secondary};
    }
`;
